import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "flex gap-x-20"
}
const _hoisted_3 = { class: "flex h-full w-full max-w-[4.8125rem] flex-col gap-y-16" }
const _hoisted_4 = { class: "aspect-product-gallery-desktop h-full w-full" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_skeleton = _resolveComponent("v-skeleton")

  return ($data.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_skeleton, { class: "aspect-product-gallery w-full" })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_skeleton, {
            rep: 3,
            class: "aspect-product-gallery-thumbnail h-full w-full"
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_skeleton, { class: "h-full w-full" })
        ])
      ]))
}